<div class="container-fluid py-4 bg-light min-vh-100">
	<!-- Header -->
	<div class="row mb-4">
		<div class="col-12">
			<div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
				<h1 class="mb-0 title">
					<i class="bi bi-journal-text me-2"></i>
					{{ 'USER_LOGS' | translate }}
				</h1>
				<div class="d-flex gap-2 hidden">
					<button class="btn btn-outline-primary" (click)="loadLogs()" [disabled]="loading">
						<i class="bi bi-arrow-clockwise me-1" [class.spinner-border]="loading"></i>
							{{ loading ? 'Cargando...' : 'Actualizar' }}
					</button>
				</div>
			</div>
		</div>
	</div>

    <!-- Error Alert -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle me-2"></i>{{ errorMessage }}
    <button type="button" class="btn-close" (click)="errorMessage = null"></button>
  </div>

	<!-- Filters Card -->
	<div class="card mb-4 shadow-sm border-0">
		<div class="card-header bg-white py-3">
			<h5 class="mb-0 text-secondary">
				<i class="bi bi-funnel me-2"></i>
				{{ 'SEARCH_FILTERS' | translate }}
			</h5>
		</div>
    <div class="card-body">
			<form (ngSubmit)="applyFilters()">
				<div class="row g-3">
					<!-- Búsqueda -->
					<div class="col-md-6">
            <label class="form-label small text-muted">{{ 'SEARCH' | translate }}</label>
            <input type="text" class="form-control form-control-sm" 
            [(ngModel)]="filters.search" name="search" 
            placeholder="Cédula, nombre o apellido del usuario">
					</div>
				
					<!-- Tipo de Log
					<div class="col-md-6">
						<label class="form-label small text-muted">{{ 'LOG_TYPE' | translate }}</label>
						<select class="form-select form-select-sm" [(ngModel)]="filters.logType" name="logType">
							<option value="">{{ 'ALL' | translate }}</option>
							<option value="USER_CREATED">✅ Created</option>
							<option value="USER_UPDATED">🔄️ Updated</option>
							<option value="USER_UPDATED">➕ Assigned</option>
							<option value="USER_LOGGED">➖ Unsigned</option>
							
						</select>
					</div> -->
				
					<!-- Fecha Inicio -->
					<div class="col-md-3">
						<label class="form-label small text-muted">{{ 'START_DATE' | translate }}</label>
						<input type="datetime-local" class="form-control form-control-sm" 
						[(ngModel)]="filters.startDate" name="startDate">
					</div>
				
					<!-- Fecha Fin -->
					<div class="col-md-3">
						<label class="form-label small text-muted">{{ 'END_DATE' | translate }}</label>
						<input type="datetime-local" class="form-control form-control-sm" [(ngModel)]="filters.endDate" name="endDate">
					</div>
				</div>
				<!-- Filter Actions -->
				<div class="row mt-3">
					<div class="col-12">
						<button type="submit" class="btn primary-btn me-2">
							<i class="bi bi-search me-1"></i>{{ 'APPLY' | translate }}
						</button>
						<button type="button" class="btn remove-btn" (click)="clearFilters()">
							<i class="bi bi-x-circle me-1"></i>{{ 'CLEAR' | translate }}
						</button>
					</div>
				</div>
			</form>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">{{ 'LOADING' | translate }}...</span>
      </div>
      <p class="mt-3 text-muted">{{ 'LOADING_LOGS' | translate }}...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && logs.length === 0" class="text-center py-5">
      <i class="bi bi-inbox display-1 text-muted"></i>
      <h4 class="mt-3 text-muted">{{ 'NO_LOGS_FOUND' | translate }}</h4>
      <p class="text-muted">{{ 'RELOAD_PAGE' | translate }}.</p>
  </div>

  <!-- Logs Table -->
  <div *ngIf="!loading && logs.length > 0" class="card shadow-sm border-0">
      
    <!-- Table Header -->
    <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
      <h5 class="mb-0 text-secondary">
        <i class="bi bi-list-ul me-2"></i>{{ 'LOGS' | translate }}
      </h5>
      <!-- <span class="badge bg-primary rounded-pill">{{ totalLogs }} {{ 'LOGS' | translate }}</span> -->
    </div>
    
    <!-- Table -->
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover table-striped mb-0 align-middle">
          <thead class="table-light">
            <tr>
              <th class="" style="width: 70px;">Log Id</th>
              <th>{{ 'USER_NAME' | translate }}</th>
              <th>{{ 'USER_ID' | translate }}</th>
              <th>{{ 'ACTION' | translate }}</th>
              <th>{{ 'RESPONSIBLE' | translate }}</th>
              <th class="">{{ 'DATE' | translate }}</th>
              <!-- <th class="text-end pe-3" style="width: 120px;">{{ 'ACTIONS' | translate }}</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of logs" 
              [class.table-success]="log.saleLogType === 'USER_CREATED'"
              [class.table-primary]="log.saleLogType === 'USER_UPDATED'"
              [class.table-danger]="log.saleLogType === 'USER_DELETED'"
              [class.table-info]="log.saleLogType === 'USER_LOGGED'"
              [class.table-warning]="log.saleLogType === 'USER_AUTH'"
              >
              <td class="ps-3"><strong class="text-muted">#{{ log.saleLogId }}</strong></td>
              <td *ngIf="!log.userData.data.firstName">{{ log.userData.data.given_name }} {{ log.userData.data.family_name }}</td>
              <td *ngIf="log.userData.data.firstName">{{ log.userData.data.firstName }} {{ log.userData.data.lastName }}</td>
              <td *ngIf="!log.userData.data.nationalId">{{ log.userData.data['custom:nationalId'] }}</td>
              <td *ngIf="log.userData.data.nationalId">{{ log.userData.data.nationalId }}</td>
              <!-- si saleLogType es "USER_CREATED" mostrar "Creado", si es "USER_UPDATED" mostrar "Actualizado", si es "USER_ASSIGNED" mostrar "Asignado", si es "USER_UNASSIGNED" mostrar "Desasignado" -->
              <td>
                <span *ngIf="log.saleLogType === 'USER_CREATED'" class="badge bg-success">
                  {{ 'USER_CREATED' | translate }}
                </span>
                <span *ngIf="log.saleLogType === 'USER_UPDATED'" class="badge bg-primary">
                  {{ 'USER_UPDATED' | translate }}
                </span>
                <!-- <span *ngIf="log.saleLogType === 'USER_DELETED'" class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle"> -->
                <span *ngIf="log.saleLogType === 'USER_DELETED'" class="badge bg-danger">
                  {{ 'USER_DELETED' | translate }}
                </span>
                <span *ngIf="log.saleLogType === 'USER_LOGGED'" class="badge bg-info">
                  {{ 'USER_LOGGED' | translate }}
                </span>
                <span *ngIf="log.saleLogType === 'USER_AUTH'" class="badge bg-warning">
                  {{ 'USER_AUTH' | translate }}
                </span>
              </td>
              <td *ngIf="log.userSnapshot.attributes">{{ log.userSnapshot.attributes.given_name+" "+log.userSnapshot.attributes.family_name || 'system' }} (Admin)</td>
              <td *ngIf="!log.userSnapshot.attributes">{{ log.userSnapshot.given_name+" "+log.userSnapshot.family_name || 'system' }}</td>
              <td *ngIf="log.userSnapshot.name">System</td>
              <td class="text-muted small">{{ formatDate(log.dateCreated) }}</td>
              <!-- <td class="text-end pe-3">
                <div class="btn-group btn-group-sm">
                <button class="btn btn-outline-primary" 
                (click)="toggleExpand(log.userLogId)"
                [attr.aria-expanded]="expandedLog === log.userLogId"
                title="Ver detalles">
                  <i class="bi" [ngClass]="expandedLog === log.userLogId ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
                <button class="btn btn-outline-secondary" 
                (click)="copyToClipboard(log)"
                title="Copiar JSON">
                  <i class="bi bi-clipboard"></i>
                </button>
                </div>
              </td> -->
            </tr>
        </tbody>
        </table>
      </div>
    </div>

      <!-- Expanded Details (per log) -->
      <div *ngFor="let log of logs">
      <div *ngIf="expandedLog === log.userLogId" class="border-top bg-light">
          <div class="p-3">
          <div class="row g-3">
              
              <!-- Request Payload -->
              <div class="col-lg-6">
              <div class="card h-100 border-primary-subtle">
                  <div class="card-header bg-primary-subtle d-flex justify-content-between align-items-center py-2">
                  <small class="fw-semibold text-primary-emphasis">
                      <i class="bi bi-arrow-right-circle me-1"></i>{{ 'REQUEST_DATA' | translate }}
                  </small>
                  <button class="btn btn-sm btn-outline-primary" 
                  (click)="copyToClipboard(log.requestPayload)"
                  [disabled]="isJsonEmpty(log.requestPayload)">
                    <i class="bi bi-clipboard me-1"></i>{{ 'COPY' | translate }}
                  </button>
                  </div>
                  <div class="card-body p-0">
                  <pre class="m-0 p-3 bg-dark text-light rounded-bottom" style="max-height: 250px; overflow-y: auto; font-size: 0.75rem;">
                    <code>{{ log.requestPayload | json }}</code>
                  </pre>
                  </div>
              </div>
              </div>
              
              <!-- Response Payload -->
              <div class="col-lg-6">
              <div class="card h-100 border-success-subtle">
                  <div class="card-header bg-success-subtle d-flex justify-content-between align-items-center py-2">
                  <small class="fw-semibold text-success-emphasis">
                      <i class="bi bi-arrow-left-circle me-1"></i>{{ 'RESPONSE_DATA' | translate }}
                  </small>
                  <button class="btn btn-sm btn-outline-success" 
                  (click)="copyToClipboard(log.responsePayload)"
                  [disabled]="isJsonEmpty(log.responsePayload)">
                    <i class="bi bi-clipboard me-1"></i>{{ 'COPY' | translate }}
                  </button>
                  </div>
                  <div class="card-body p-0">
                  <pre class="m-0 p-3 bg-dark text-light rounded-bottom" style="max-height: 250px; overflow-y: auto; font-size: 0.75rem;">
                    <code>{{ log.responsePayload | json }}</code>
                  </pre>
                  </div>
              </div>
              </div>
              
              <!-- Customer Snapshot (full width) -->
              <div class="col-12" *ngIf="!isJsonEmpty(log.customerSnapshot)">
              <div class="card border-info-subtle">
                  <div class="card-header bg-info-subtle py-2">
                  <small class="fw-semibold text-info-emphasis">
                    <i class="bi bi-person me-1"></i>{{ 'CUSTOMER_SNAPSHOT' | translate }}
                  </small>
                  </div>
                  <div class="card-body p-0">
                  <pre class="m-0 p-3 bg-dark text-light rounded-bottom" style="max-height: 200px; overflow-y: auto; font-size: 0.75rem;">
                    <code>{{ log.customerSnapshot | json }}</code>
                  </pre>
                  </div>
              </div>
              </div>
              
          </div>
          </div>
      </div>
      </div>
      
      <!-- Pagination -->
      <div class="card-footer bg-white py-3" *ngIf="totalPages > 1">
        <nav aria-label="Paginación de logs">
          <ul class="pagination justify-content-center mb-0">
          
          <!-- Previous -->
          <li class="page-item" [class.disabled]="currentPage === 1">
            <button class="page-link" (click)="goToPage(currentPage - 1)">
              <i class="bi bi-chevron-left"></i>
            </button>
          </li>
          
          <!-- Page Numbers -->
          <li class="page-item" *ngFor="let page of getPagesArray()" [class.active]="currentPage === page">
            <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
          </li>
          
          <!-- Next -->
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <button class="page-link" (click)="goToPage(currentPage + 1)">
              <i class="bi bi-chevron-right"></i>
            </button>
          </li>
          
          </ul>
        </nav>
      </div>
  </div>
</div>